import {useTranslation} from 'react-i18next';
import {StatusModal, StatusModalStates} from '@chekin/shared';

type Props = {
  isOpen: boolean;
  status: StatusModalStates;
};

function SearchingBookingModal({isOpen, status}: Props) {
  const {t} = useTranslation();

  return (
    <StatusModal
      open={isOpen}
      state={status}
      maxWidth="675px"
      className="searching-booking-modal"
    >
      {status === StatusModalStates.LOADING && (
        <div className="text-lg font-semibold leading-6 tracking-[0.36px] text-center text-primary kiosko:text-kiosko-l">
          {t('searching_booking')}
        </div>
      )}
      {status === StatusModalStates.SUCCESS && (
        <div className="text-lg font-semibold leading-6 tracking-[0.36px] text-center text-primary kiosko:text-kiosko-l">
          {t('booking_found')}
        </div>
      )}
    </StatusModal>
  );
}

export {SearchingBookingModal};
